<div class="st-drawer-wrapper">
  <a href=""></a>
  <!--  Header  -->
  <div class="st-drawer-header">
    <span *ngIf="step !== 3" class="text-header-18 text-semibold">Añadir tarea a "{{nzData.project.name}}"</span>
    <div *ngIf="step === 3" class="st-header-inner-group flex-center gap-100">
      <button (click)="cancelAddOrEditEvent()" nz-button nzType="text" nzSize="default" nzShape="circle" class="text-btn-16">
        <app-st-icon class="flex-center" [bold]="true" name="arrow_back"></app-st-icon>
      </button>
      <span *ngIf="selectedEvent?.name" class="text-header-18 text-semibold">Editar Evento "{{selectedEvent?.name}}"</span>
      <span *ngIf="!selectedEvent" class="text-header-18 text-semibold">Añadir Evento</span>
    </div>
    <app-st-icon *ngIf="step !== 3" (click)="close()" class="text-header-16 cursor-pointer" [name]="'close'" [bold]="true"></app-st-icon>
  </div>

  <!--  Content  -->
  <div class="st-drawer-content">

    <!--  Stepper  -->
    <div *ngIf="step !== 3" class="stepper">
      <div class="stepper-item" [ngClass]="{'active': step === 1}" (click)="step = 1">
        <span>1. Detalles</span>
      </div>

      <app-st-icon name="keyboard_arrow_right"></app-st-icon>

      <div class="stepper-item" [ngClass]="{'active': step === 2}" (click)="stepOneValid() ? step = 2 : null">
        <span>2. Flujo</span>
      </div>
    </div>

    <!--  Service Form  -->
    <form *ngIf="step === 1" class="st-form" nz-form [formGroup]="serviceForm">
      <!-- Nombre de la tarea (Requerido) -->
      <nz-form-item>
        <nz-form-label [nzSpan]="24" nzRequired>Nombre de la tarea</nz-form-label>
        <nz-form-control [nzErrorTip]="'Este campo es requerido'">
          <input type="text" nzSize="large" nz-input formControlName="service"
                 placeholder="Introduce Nombre de la tarea..." />
        </nz-form-control>
      </nz-form-item>

      <!-- Tipo de Servicio (Requerido) -->
      <nz-form-item>
        <nz-form-label [nzSpan]="24" nzRequired>Tipo</nz-form-label>
        <nz-form-control [nzErrorTip]="'Este campo es requerido'">
          <nz-select [nzSuffixIcon]="customSelectIcon" nzSize="large"
                     [nzCustomTemplate]="typeServiceSelectTpmpl"
                     formControlName="serviceTypeId">

            <!-- Opciones del select -->
            <nz-option *ngFor="let type of serviceTypes" [nzLabel]="type.name" [nzValue]="type.id" nzCustomContent>
              <div class="flex gap-150">
                <app-st-icon [bold]="true" [name]="type.icon || 'close'"></app-st-icon>
                <p>{{type.name}}</p>
              </div>
            </nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>

      <!-- Fecha Inicio -->
      <div nz-row [nzGutter]="16">
        <!-- Fecha Inicio -->
        <div nz-col [nzXs]="24" [nzSm]="12">
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Fecha inicio plan.</nz-form-label>
            <nz-form-control>
              <nz-input-group nzSize="large" class="addon-after" [nzAddOnAfter]="suffixTmpl">
                <nz-date-picker nzSize="large" [nzSuffixIcon]="emtySuffixTmpl" class="w-100" formControlName="startDate"
                                nzPlaceHolder="Introduce Fecha inicio plan...." nzFormat="dd-MM-yyyy"
                                [nzDisabledDate]="disabledStartDate(serviceForm.get('endDate')?.value)" ></nz-date-picker>
              </nz-input-group>
            </nz-form-control>
          </nz-form-item>
        </div>


        <!-- Fecha Fin -->
        <div nz-col [nzXs]="24" [nzSm]="12">
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Fecha fin plan.</nz-form-label>
            <nz-form-control>
              <nz-input-group nzSize="large" class="addon-after" [nzAddOnAfter]="suffixTmpl">
                <nz-date-picker nzSize="large" [nzSuffixIcon]="emtySuffixTmpl" class="w-100" formControlName="endDate"
                                nzPlaceHolder="Introduce Fecha fin plan...." nzFormat="dd-MM-yyyy"
                                [nzDisabledDate]="disabledEndDate(serviceForm.get('startDate')?.value)"></nz-date-picker>
              </nz-input-group>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>

      <!-- Integrar con Mojito360 -->
      <nz-form-item *ngIf="false">
        <nz-form-control>
          <label formControlName="integrate" nz-checkbox>Integrar con Mojito360</label>
        </nz-form-control>
      </nz-form-item>

      <!-- Secciones colapsables -->
      <nz-collapse [nzBordered]="false" class="key-item-collapse medium-header-padding">
        <!-- Seccion colapsable de Agentes -->
        <nz-collapse-panel *ngIf="false" #agents [nzShowArrow]="false" [nzHeader]="agentsNameTmpl">
          <ng-template #agentsNameTmpl>
            <app-collapse-panel-header [minHeight]="'0px'" [panelActive]="agents.nzActive" [onlyText]="'Agentes'"></app-collapse-panel-header>
          </ng-template>

          <!-- Contenido de Agentes -->
          <div nz-row [nzGutter]="16">
            <!-- Forwarder -->
<!--            <div nz-col [nzXs]="24" [nzSm]="12">-->
<!--              <nz-form-item>-->
<!--                <nz-form-label [nzSpan]="24">Forwarder</nz-form-label>-->
<!--                <nz-form-control>-->
<!--                  <app-avatar-select-->
<!--                    formControlName="forwarderId"-->
<!--                    [options]="forwarderList"-->
<!--                    placeholder="Selecciona Forwarder...">-->
<!--                  </app-avatar-select>-->
<!--                </nz-form-control>-->
<!--              </nz-form-item>-->
<!--            </div>-->

            <!-- Proveedor -->
            <div nz-col [nzXs]="24" [nzSm]="12">
              <nz-form-item>
                <nz-form-label [nzSpan]="24">Proveedor</nz-form-label>
                <nz-form-control>
                  <app-avatar-select
                    formControlName="provedorId"
                    [options]="providers"
                    placeholder="Selecciona el proveedor...">
                  </app-avatar-select>
                </nz-form-control>
              </nz-form-item>
            </div>

            <!-- Expedidor -->
            <div nz-col [nzXs]="24" [nzSm]="12">
              <nz-form-item>
                <nz-form-label [nzSpan]="24">Expedidor</nz-form-label>
                <nz-form-control>
                  <app-avatar-select
                    formControlName="origenContactId"
                    [options]="origenContactList"
                    placeholder="Selecciona el expedidor...">
                  </app-avatar-select>
                </nz-form-control>
              </nz-form-item>
            </div>
          </div>

          <div nz-row [nzGutter]="16">


            <!-- Destinatario -->
            <div nz-col [nzXs]="24" [nzSm]="12">
              <nz-form-item>
                <nz-form-label [nzSpan]="24">Destinatario</nz-form-label>
                <nz-form-control>
                  <app-avatar-select
                    formControlName="destinationContactId"
                    [options]="destinyContactList"
                    placeholder="Selecciona el Destinatario...">
                  </app-avatar-select>
                </nz-form-control>
              </nz-form-item>
            </div>
          </div>
        </nz-collapse-panel>

        <!-- Seccion colapsable de Transporte -->
        <nz-collapse-panel *ngIf="false" #transporte [nzShowArrow]="false" [nzHeader]="transporteNameTmpl">
          <ng-template #transporteNameTmpl>
            <app-collapse-panel-header [minHeight]="'0px'"  [panelActive]="transporte.nzActive" [onlyText]="'Ruta'"></app-collapse-panel-header>
          </ng-template>

          <!-- Contenido de Transporte -->
          <div nz-row [nzGutter]="16">
            <!-- Origen -->
            <div nz-col [nzXs]="24" [nzSm]="12">
              <nz-form-item>
                <nz-form-label [nzSpan]="24">Origen</nz-form-label>
                <nz-form-control>
                  <nz-select [nzClearIcon]="customClearIcon" [nzSuffixIcon]="customSelectIcon" nzAllowClear nzSize="large"
                             nzShowSearch formControlName="origin" nzPlaceHolder="Selecciona el Origen...">
                    <nz-option *ngFor="let place of locations" [nzLabel]="place.name"
                               [nzValue]="place"></nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
            </div>

            <!-- Destino -->
            <div nz-col [nzXs]="24" [nzSm]="12">
              <nz-form-item>
                <nz-form-label [nzSpan]="24">Destino</nz-form-label>
                <nz-form-control>
                  <nz-select [nzClearIcon]="customClearIcon" [nzSuffixIcon]="customSelectIcon" nzAllowClear nzSize="large"
                             nzShowSearch formControlName="destination" nzPlaceHolder="Selecciona el Destino...">
                    <nz-option *ngFor="let place of locations" [nzLabel]="place.name"
                               [nzValue]="place"></nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
            </div>
          </div>
        </nz-collapse-panel>

        <!-- Seccion colapsable de Especificaciones -->
        <nz-collapse-panel *ngIf="false" #especificaciones [nzShowArrow]="false" [nzHeader]="especificacionesNameTmpl">
          <ng-template #especificacionesNameTmpl>
            <app-collapse-panel-header [minHeight]="'0px'" [panelActive]="especificaciones.nzActive" [onlyText]="'Especificaciones'"></app-collapse-panel-header>
          </ng-template>

          <!-- Contenido de Especificaciones -->
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Especificaciones técnicas</nz-form-label>
            <nz-form-control>
              <textarea type="text" nzSize="large" nz-input formControlName="technicalSpecifications" rows="4"
                        placeholder="Especificaciones técnicas..." ></textarea>
            </nz-form-control>
          </nz-form-item>

          <nz-form-item>
            <nz-form-label [nzSpan]="24">Operaciones personalizadas</nz-form-label>
            <nz-form-control>
              <input type="text" nzSize="large" nz-input formControlName="customOperations"
                     placeholder="Introduce Operaciones personalizadas..." />
            </nz-form-control>
          </nz-form-item>

          <!-- Frecuencia -->
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Frecuencia de entrega</nz-form-label>
            <nz-form-control>
              <input type="text" nzSize="large" nz-input formControlName="frequency"
                     placeholder="Introduce Frecuencia de entrega..." />
            </nz-form-control>
          </nz-form-item>
        </nz-collapse-panel>

          <!-- Seccion colapsable de Presupuesto Total -->
          <nz-collapse-panel *ngIf="false" #cotizacionTotal [nzShowArrow]="false" [nzHeader]="cotizacionTotalNameTmpl" formGroupName="servicePricing">
            <ng-template #cotizacionTotalNameTmpl>
              <app-collapse-panel-header [minHeight]="'0px'" [panelActive]="cotizacionTotal.nzActive"
                                         [onlyText]="'Presupuesto'"></app-collapse-panel-header>
            </ng-template>
            <div nz-row [nzGutter]="16">
              <div nz-col [nzXs]="24" [nzSm]="12">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24">Cantidad</nz-form-label>
                  <nz-form-control>
                    <input type="number" nzSize="large" nz-input formControlName="totalQuantity"
                           placeholder="Introduce la cantidad total..."/>
                  </nz-form-control>
                </nz-form-item>
              </div>

              <div nz-col [nzXs]="24" [nzSm]="12">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24">Precio</nz-form-label>
                  <nz-form-control>
                    <input type="number" nzSize="large" nz-input formControlName="totalPrice"
                           placeholder="Introduce el precio total..."/>
                  </nz-form-control>
                </nz-form-item>
              </div>

            </div>
            <div nz-row [nzGutter]="16">
              <div nz-col [nzXs]="24" [nzSm]="12">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24">Costo</nz-form-label>
                  <nz-form-control>
                    <input type="number" nzSize="large" nz-input formControlName="totalCost"
                           placeholder="Introduce el costo total..."/>
                  </nz-form-control>
                </nz-form-item>
              </div>
              <div nz-col [nzXs]="24" [nzSm]="12">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24">Descuento</nz-form-label>
                  <nz-form-control>
                    <input type="number" nzSize="large" nz-input formControlName="totalDiscount"
                           placeholder="Introduce el descuento total..."/>
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>
            <div nz-row [nzGutter]="16">
              <div nz-col [nzXs]="24" [nzSm]="12">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24">VAT de ventas</nz-form-label>
                  <nz-form-control>
                    <input type="number" nzSize="large" nz-input formControlName="totalSaleVat"
                           placeholder="Introduce el VAT de ventas..." />
                  </nz-form-control>
                </nz-form-item>
              </div>
              <div nz-col [nzXs]="24" [nzSm]="12">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24">VAT total de compras</nz-form-label>
                  <nz-form-control>
                    <input type="number" nzSize="large" nz-input formControlName="totalPurchaseVat"
                           placeholder="Introduce el VAT total de compras..." />
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>
            <div nz-col [nzXs]="24" [nzSm]="12">
              <nz-form-item>
                <nz-form-label [nzSpan]="24">Total unitario</nz-form-label>
                <nz-form-control>
                  <nz-select nzSize="large" formControlName="totalUnit" nzPlaceHolder="Selecciona la unidad...">
                    <nz-option *ngFor="let unit of pricingUnits"
                               [nzValue]="unit"
                               [nzLabel]="unit | pricingUnit"></nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
            </div>
          </nz-collapse-panel>

          <!-- Seccion colapsable de Presupuesto Unitaria -->
          <nz-collapse-panel *ngIf="false" #cotizacionUnitaria [nzShowArrow]="false" [nzHeader]="cotizacionUnitariaNameTmpl" formGroupName="servicePricing">
            <ng-template #cotizacionUnitariaNameTmpl>
              <app-collapse-panel-header [minHeight]="'0px'" [panelActive]="cotizacionUnitaria.nzActive"
                                         [onlyText]="'Presupuesto Unitaria'"></app-collapse-panel-header>
            </ng-template>
            <div nz-row [nzGutter]="16">
              <div nz-col [nzXs]="24" [nzSm]="12">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24">Cantidad unitaria</nz-form-label>
                  <nz-form-control>
                    <input type="number" nzSize="large" nz-input formControlName="unitQuantity"
                           placeholder="Introduce la cantidad unitaria..."/>
                  </nz-form-control>
                </nz-form-item>
              </div>

              <div nz-col [nzXs]="24" [nzSm]="12">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24">Precio unitario</nz-form-label>
                  <nz-form-control>
                    <input type="number" nzSize="large" nz-input formControlName="unitPrice"
                           placeholder="Introduce el precio unitario..."/>
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>
            <div nz-row [nzGutter]="16">
              <div nz-col [nzXs]="24" [nzSm]="12">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24">Costo unitario</nz-form-label>
                  <nz-form-control>
                    <input type="number" nzSize="large" nz-input formControlName="unitCost"
                           placeholder="Introduce el costo unitario..."/>
                  </nz-form-control>
                </nz-form-item>
              </div>
              <div nz-col [nzXs]="24" [nzSm]="12">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24">Descuento unitario</nz-form-label>
                  <nz-form-control>
                    <input type="number" nzSize="large" nz-input formControlName="unitDiscount"
                           placeholder="Introduce el descuento unitario..."/>
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>
            <div nz-row [nzGutter]="16">
              <div nz-col [nzXs]="24" [nzSm]="12">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24">VAT de compras unitario</nz-form-label>
                  <nz-form-control>
                    <input type="number" nzSize="large" nz-input formControlName="unitPurchaseVat"
                           placeholder="Introduce el VAT de compras unitario..."/>
                  </nz-form-control>
                </nz-form-item>
              </div>
              <div nz-col [nzXs]="24" [nzSm]="12">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24">VAT de ventas unitario</nz-form-label>
                  <nz-form-control>
                    <input type="number" nzSize="large" nz-input formControlName="unitSaleVat"
                           placeholder="Introduce el VAT de ventas unitario..."/>
                  </nz-form-control>
                </nz-form-item>
              </div>
<!--              <div nz-col [nzXs]="24" [nzSm]="12">-->
<!--                <nz-form-item>-->
<!--                  <nz-form-label [nzSpan]="24">Moneda</nz-form-label>-->
<!--                  <nz-form-control>-->
<!--                    <nz-select [nzClearIcon]="customClearIcon" [nzSuffixIcon]="customSelectIcon" nzAllowClear-->
<!--                               nzSize="large" nzShowSearch-->
<!--                               formControlName="currencyId" nzPlaceHolder="Selecciona la moneda...">-->
<!--                      <nz-option *ngFor="let currency of currencies" [nzLabel]="currency.name"-->
<!--                                 [nzValue]="currency.id"></nz-option>-->
<!--                    </nz-select>-->
<!--                  </nz-form-control>-->
<!--                </nz-form-item>-->
<!--              </div>-->
            </div>
            <div nz-row [nzGutter]="16">
              <div nz-col [nzXs]="24" [nzSm]="12">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24">Unidad</nz-form-label>
                  <nz-form-control>
                    <nz-select nzSize="large"  formControlName="unit" nzPlaceHolder="Selecciona la unidad...">
                      <nz-option *ngFor="let unit of pricingUnits"
                                 [nzValue]="unit"
                                 [nzLabel]="unit | pricingUnit"></nz-option>
                    </nz-select>
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>
          </nz-collapse-panel>
      </nz-collapse>
    </form>

    <!--  Contenido de Flujo  -->
    <div *ngIf="step === 2" class="flow-content-wrapper">
      <span class="text-label-14 text-dark">
        El flujo es la secuencia de eventos que sigue un servicio hasta completarse. Puedes usar un flujo que se haya
        predefinido en <a href="http://localhost">Catálogos > Flujos</a> o adaptarlo para este servicio si lo necesitas.
      </span>

      <!-- Select para seleccionar el flujo -->
      <form class="st-form" nz-form [formGroup]="serviceForm">
        <nz-form-item style="margin: 0">
          <nz-form-label [nzSpan]="24" nzRequired>Estado</nz-form-label>
          <nz-form-control [nzErrorTip]="'Este campo es requerido'">
            <nz-select [nzSuffixIcon]="customSelectIcon" nzSize="large" formControlName="flow" nzShowSearch>
              <nz-option *ngFor="let event of allEvents" [nzLabel]="event.displayName" [nzValue]="event.flowId"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </form>

      <!-- Lista de eventos del flujo dado -->
      <app-event-cards-dragables *ngIf="events"
                                 [events]="events"
                                 (openAddOrEditEvent)="openAddOrEditEvent($event)"
      ></app-event-cards-dragables>
    </div>

    <!--  Contenido de Eventos y Activator  -->
    <div *ngIf="step === 3 && eventForm && activatorForm" class="flow-content-wrapper">
      <app-event-activator-section
        [event]="selectedEvent"
        [eventsLenght]="events.length"
        [(activatorForm)]="activatorForm"
        [(eventForm)]="eventForm"
      ></app-event-activator-section>
    </div>

  </div>

  <!--  Footer  -->
  <div class="st-drawer-footer" [class.show-border]="step !== 1">
    <button (click)="close()" class="text-btn-14" nz-button nzType="text" nzShape="round" nzSize="large">Cancelar</button>

    <button (click)="step = 2" *ngIf="step === 1" [disabled]="!stepOneValid()"
            class="text-btn-14" nz-button nzType="default" nzShape="round" nzSize="large">
      <span>Siguiente</span>
      <app-st-icon class="sufix" [name]="'arrow_forward'" [bold]="true"></app-st-icon>
    </button>

    <div *ngIf="step === 2" class="flex gap-200">
      <button  [disabled]="!isServiceFormValid()" (click)="createService(false)"
              class="text-btn-14" nz-button nzType="default" nzShape="round" nzSize="large">
        <app-st-icon *ngIf="creatingService === 2" class="prefix" [name]="'progress_activity'" [bold]="true"></app-st-icon>
        <span>Añadir y seguir añadiendo</span>
      </button>

      <button (click)="createService(true)" [disabled]="!isServiceFormValid()"
              class="text-btn-14" nz-button nzType="primary" nzShape="round" nzSize="large">
        <app-st-icon *ngIf="creatingService !== 1" class="prefix" [name]="'add'" [bold]="true"></app-st-icon>
        <app-st-icon *ngIf="creatingService === 1" class="prefix" [name]="'progress_activity'" [bold]="true"></app-st-icon>
        <span>Añadir tarea</span>
      </button>
    </div>

    <button *ngIf="step === 3" [disabled]="!isFormsValids()" (click)="confirmAddOrEditEvent()"
            class="text-btn-14" nz-button nzType="primary" nzShape="round" nzSize="large">
      <span>{{ selectedEvent ? 'Editar' : 'Añadir' }} Evento</span>
    </button>
  </div>
</div>

<ng-template #customSelectIcon>
  <app-st-icon class="custom-suffix" name="keyboard_arrow_down"></app-st-icon>
</ng-template>
<ng-template #customClearIcon>
  <app-st-icon class="custom-clear" name="close"></app-st-icon>
</ng-template>

<ng-template #suffixTmpl>
  <app-st-icon style="font-size: 20px" color="#666666" [bold]="true" name="calendar_today"></app-st-icon>
</ng-template>
<ng-template #emtySuffixTmpl>
</ng-template>

<!--  Notification  -->
<ng-template #notificationTmpl>
  <app-toast *ngIf="notRef" [icon]="toastConfig.icon" [iconColor]="toastConfig.iconColor" [showUndo]="toastConfig.showUndo"
             [notRef]="notRef" [content]="toastConfig.content" [msg]="toastConfig.msg"></app-toast>
</ng-template>
<ng-template #typeServiceSelectTpmpl let-selected>
  <app-st-icon class="text-label-16" [name]="getServicecTypeIcon(selected.nzValue)"></app-st-icon> <span> {{selected.nzLabel}}</span>
</ng-template>
<ng-template #iconSelectTpmpl let-selected>
  <app-st-icon [name]="selected.nzValue"></app-st-icon>
</ng-template>

<ng-template #colorSelectTpmpl let-selected>
  <app-st-icon [color]="selected.nzValue" [filled]="true" name="fiber_manual_record"></app-st-icon>
</ng-template>
